import { render } from "./lists.vue?vue&type=template&id=00f2c73d&scoped=true&ts=true"
import script from "./lists.vue?vue&type=script&lang=ts"
export * from "./lists.vue?vue&type=script&lang=ts"

import "./lists.vue?vue&type=style&index=0&id=00f2c73d&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f2c73d"]])

export default __exports__